import { isNaN, isNumber, toString, trim } from "lodash-es";

const parseBoolConfig: Record<string, boolean> = {
	// truthy
	true: true,
	yes: true,
	y: true,
	on: true,
	// falsy
	false: false,
	no: false,
	n: false,
	off: false,
};

/**
 * Converts the given object to boolean.
 * @param value The provided object value to convert.
 * @returns A boolean value corresponding to the given object.
 */
export function toBoolean(value: string | number | boolean | null | undefined): boolean | undefined {
	if (!isNaN(value) && isNumber(value)) {
		return value > 0;
	}

	return parseBoolConfig[trim(toString(value).toLowerCase())];
}
